import { useState } from 'react';
import type { DailyResponse } from '../types';
import { api } from '../api';
import { useI18n } from '../i18n';

export function DailyPlan() {
  const { t, locale } = useI18n();
  const [focus, setFocus] = useState('');
  const [plan, setPlan] = useState<DailyResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function generate() {
    setLoading(true);
    setError(null);
    try {
      const p = await api.daily(focus.trim() || undefined, undefined, locale);
      setPlan(p);
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <header className="page-header">
        <div>
          <h1 className="page-title">{t('daily.title')}</h1>
          <div className="page-sub">{t('daily.subtitle')}</div>
        </div>
      </header>

      <section className="card">
        <div className="field-row">
          <input
            className="input"
            placeholder={t('daily.focus.placeholder')}
            value={focus}
            onChange={(e) => setFocus(e.target.value)}
          />
          <button className="btn btn-primary" onClick={generate} disabled={loading}>
            {loading ? t('daily.generating') : t('daily.generate')}
          </button>
        </div>
        {error && (
          <div className="error-banner" style={{ marginTop: 12 }}>
            {error}
          </div>
        )}
      </section>

      {plan && (
        <>
          <section className="card">
            <h2 className="card-title">{plan.date}</h2>
            <div style={{ fontSize: 15, lineHeight: 1.55 }}>{plan.summary}</div>
            {plan.topPriorities.length > 0 && (
              <>
                <div className="ai-section-title">{t('daily.section.priorities')}</div>
                <ul className="bullet-list">
                  {plan.topPriorities.map((p, i) => (
                    <li key={i}>{p}</li>
                  ))}
                </ul>
              </>
            )}
          </section>

          <section className="card">
            <h2 className="card-title">{t('daily.section.schedule')}</h2>
            {plan.schedule.length === 0 ? (
              <div className="empty">{t('daily.empty.schedule')}</div>
            ) : (
              <ul className="schedule-list">
                {plan.schedule.map((b, i) => (
                  <li key={i} className="schedule-row">
                    <div className="schedule-time">{b.time}</div>
                    <div>
                      <div className="schedule-title">{b.title}</div>
                      {b.notes && <div className="schedule-notes">{b.notes}</div>}
                    </div>
                  </li>
                ))}
              </ul>
            )}
          </section>
        </>
      )}
    </>
  );
}
